import { lazy } from 'react'

import { authRoles } from '../../../../../auth/authRoles'
import Loadable from '../../../../base/components/Template/Loadable/Loadable'
import { emailRoutesMap } from './EmailRoutesMap'

const AppEmailGestion = Loadable(lazy(() => import('./view/listado/Email')))
const AppEmailNuevo = Loadable(lazy(() => import('./view/registro/EmailRegistro')))
const AppEmailActualizar = Loadable(
  lazy(() => import('./view/actualizar/EmailActualizar')),
)

const emailRoutes = [
  {
    path: emailRoutesMap.gestion.path,
    element: <AppEmailGestion />,
    auth: authRoles.admin,
  },
  {
    path: emailRoutesMap.nuevo.path,
    element: <AppEmailNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${emailRoutesMap.modificar.path}/:id`,
    element: <AppEmailActualizar />,
    auth: authRoles.admin,
  },
]

export default emailRoutes
